function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { memo } from "react";
var SvgSmsSocial = function SvgSmsSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.1665 2.66667H5.83317C4.3665 2.66667 3.1665 3.86667 3.1665 5.33334V29.3333L8.49984 24H27.1665C28.6332 24 29.8332 22.8 29.8332 21.3333V5.33334C29.8332 3.86667 28.6332 2.66667 27.1665 2.66667ZM27.1665 21.3333H8.49984L5.83317 24V5.33334H27.1665V21.3333ZM9.83317 12H12.4998V14.6667H9.83317V12ZM15.1665 12H17.8332V14.6667H15.1665V12ZM20.4998 12H23.1665V14.6667H20.4998V12Z",
    fill: "url(#paint0_linear_7878_34312)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7878_34312",
    x1: 3.1665,
    y1: 5.95262,
    x2: 29.8332,
    y2: 26.0474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFEBA5"
    }, "stopColor", "color(display-p3 1.0000 0.9216 0.6471)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7804 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFE27B"
    }, "stopColor", "color(display-p3 1.0000 0.8863 0.4824)"), "stopOpacity", 1)
  }))));
};
var Memo = /*#__PURE__*/memo(SvgSmsSocial);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/sms-social.80010b3782209004103591e9ebb02274.svg";